

export abstract class BaseRequest { }